// CCRS Calculation Parameters
export const CROP_PARAMS = {
  Padi: {
    Rain: { min: 15, il: 20, ih: 35, max: 45, bobot: 0.3 },
    Wind: { min: 0, il: 1, ih: 3, max: 6, bobot: 0.08 },
    Humidity: { min: 60, il: 70, ih: 90, max: 100, bobot: 0.1 },
    Visibility: { min: 3, il: 8, ih: 12, max: 20, bobot: 0.01 },
    Pressure: { min: 980, il: 1000, ih: 1015, max: 1035, bobot: 0.02 },
    UV: { min: 1, il: 4, ih: 7, max: 11, bobot: 0.05 },
    DewPoint: { min: 15, il: 22, ih: 26, max: 32, bobot: 0.04 },
    SoilMoisture: { min: 40, il: 65, ih: 85, max: 100, bobot: 0.25 },
    pH: { min: 4.5, il: 5.8, ih: 6.8, max: 8, bobot: 0.15 }
  },
  Jagung: {
    Rain: { min: 5, il: 15, ih: 25, max: 40, bobot: 0.2 },
    Wind: { min: 0, il: 1, ih: 4, max: 8, bobot: 0.1 },
    Humidity: { min: 40, il: 60, ih: 75, max: 100, bobot: 0.12 },
    Visibility: { min: 3, il: 8, ih: 15, max: 20, bobot: 0.03 },
    Pressure: { min: 980, il: 1000, ih: 1015, max: 1035, bobot: 0.04 },
    UV: { min: 1, il: 5, ih: 8, max: 11, bobot: 0.08 },
    DewPoint: { min: 10, il: 18, ih: 24, max: 30, bobot: 0.05 },
    SoilMoisture: { min: 20, il: 50, ih: 70, max: 100, bobot: 0.18 },
    pH: { min: 4.5, il: 5.8, ih: 7, max: 8, bobot: 0.2 }
  }
};

// Fuzzy membership function
export const calculateMembership = (value, min, il, ih, max) => {
  if (value >= il && value <= ih) {
    return 1;
  } else if (value < il) {
    return Math.max(0, 1 - (il - value) / (il - min));
  } else {
    return Math.max(0, 1 - (value - ih) / (max - ih));
  }
};

// Calculate CCRS
export const calculateCCRS = (crop, inputs) => {
  const params = CROP_PARAMS[crop];
  let totalScore = 0;

  Object.keys(inputs).forEach(param => {
    const value = parseFloat(inputs[param]);
    const p = params[param];
    
    if (p && !isNaN(value)) {
      const membership = calculateMembership(value, p.min, p.il, p.ih, p.max);
      totalScore += membership * p.bobot * 100;
    }
  });

  return totalScore;
};

// Get status based on CCRS
export const getStatus = (ccrs) => {
  if (ccrs > 85) return { text: 'Sangat Layak', color: '#28a745' };
  if (ccrs >= 70) return { text: 'Layak', color: '#17a2b8' };
  if (ccrs >= 55) return { text: 'Perlu Perhatian', color: '#ffc107' };
  return { text: 'Tunda Tanam', color: '#dc3545' };
};

export const PARAM_LABELS = {
  Rain: 'Curah Hujan (mm)',
  Wind: 'Wind (m/s)',
  Humidity: 'Humidity (%)',
  Visibility: 'Visibility (km)',
  Pressure: 'Pressure (hPa)',
  UV: 'UV Index',
  DewPoint: 'Dew Point (°C)',
  SoilMoisture: 'Soil Moisture (%)',
  pH: 'pH'
};
